<p>{{datos.value}}</p>
<input [(ngModel)]="code" *ngIf="datos" class="input-sca" placeholder="Código"
  type="{{datos.type}}" name="" id="codeSca">
<div class="container-btn">
  <button [ngClass]="{'rapidScore': data.isRapidScore}" (click)="closeModal(true)" id="acceptModalSCA" type="submit">Aceptar</button>
</div>
